"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.justifyContent = exports.flexWrap = exports.flexShrink = exports.flexGrow = exports.flexDirection = exports.alignSelf = exports.alignItems = exports.alignContent = void 0;
require("./flex.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const alignContent = {
  'flex-start': "cds-flex-start-frunukt",
  'flex-end': "cds-flex-end-f1qqwkms",
  center: "cds-center-cv8796s",
  stretch: "cds-stretch-sfw4afa",
  'space-between': "cds-space-between-sevhv5h",
  'space-around': "cds-space-around-s11hbwr7"
};
exports.alignContent = alignContent;
const alignItems = {
  'flex-start': "cds-flex-start-f1lnfmfd",
  'flex-end': "cds-flex-end-f9tvb5a",
  center: "cds-center-ca5ylan",
  stretch: "cds-stretch-s5nqxyn",
  baseline: "cds-baseline-b1fcn5pa"
};
exports.alignItems = alignItems;
const alignSelf = {
  'flex-start': "cds-flex-start-fpd59q1",
  'flex-end': "cds-flex-end-fb2j2v1",
  center: "cds-center-c1yvpj9g",
  stretch: "cds-stretch-s18bbwip",
  baseline: "cds-baseline-b10662dz",
  auto: "cds-auto-ao3sce2"
};
exports.alignSelf = alignSelf;
const flexDirection = {
  row: "cds-row-r1tfxker",
  column: "cds-column-ci8mx7v",
  'row-reverse': "cds-row-reverse-r1lezl4s",
  'column-reverse': "cds-column-reverse-c1skacs4"
};
exports.flexDirection = flexDirection;
const flexWrap = {
  wrap: "cds-wrap-weyjhf0",
  nowrap: "cds-nowrap-n1jb5thv",
  'wrap-reverse': "cds-wrap-reverse-wn5kp09"
};
exports.flexWrap = flexWrap;
const justifyContent = {
  'flex-start': "cds-flex-start-f1urtf06",
  'flex-end': "cds-flex-end-f15z3vlp",
  center: "cds-center-czxavit",
  'space-between': "cds-space-between-s1vbz1",
  'space-around': "cds-space-around-sjq70cl",
  'space-evenly': "cds-space-evenly-scvlr45"
};
exports.justifyContent = justifyContent;
const flexShrink = {
  1: "cds-1-_1ncw0nb",
  2: "cds-2-_18fc32x",
  3: "cds-3-_11lj67p"
};
exports.flexShrink = flexShrink;
const flexGrow = {
  1: "cds-1-_jm1lhd",
  2: "cds-2-_1ss4f0f",
  3: "cds-3-_1sswfz2"
};
exports.flexGrow = flexGrow;